/**
 * Sample data for auto-fill on Leave Entitlement create page.
 * Keys in daysByCode match leave type codes (e.g. from seed: sick, annual, unpaid, compassionate).
 * When applying, we map code -> leaveTypeId using loaded leave types and set days.
 */
export type LeaveEntitlementCreateFormSample = {
  year: number;
  /** Days per leave type by code (sick, annual, unpaid, compassionate, etc.) */
  daysByCode: Record<string, number>;
};

export const leaveEntitlementCreateFormSamples: LeaveEntitlementCreateFormSample[] =
  [
    {
      year: new Date().getFullYear(),
      daysByCode: {
        sick: 30,
        annual: 15,
        unpaid: 10,
        compassionate: 5,
      },
    },
    {
      year: new Date().getFullYear(),
      daysByCode: {
        sick: 15,
        annual: 12,
        unpaid: 5,
      },
    },
    {
      year: new Date().getFullYear() + 1,
      daysByCode: {
        sick: 30,
        annual: 20,
        unpaid: 10,
        compassionate: 7,
      },
    },
  ];
